@if (loading) {
<div [class.card]="card" class="border-0">
  <div [class.body]="card">
    <div class="fetching mb-3 mt-3 col-lg-12 col-md-12 col-sm-12" style="text-align: center">
      <i class="pi pi-spin pi-spinner"></i>
      {{loadingText}}
    </div>
  </div>
</div>
}